import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const confidenceMaterializedSegmentsPlugin = createPlugin({
  id: 'confidence-flags-module-materialized-segments',
  routes: {
    ...Routes,
  },
});

export const ConfidenceMaterializedSegmentsExtension =
  confidenceMaterializedSegmentsPlugin.provide(
    createRoutableExtension({
      name: 'ConfidenceMaterializedSegmentsExtension',
      component: () =>
        import(
          /* webpackChunkName: "confidence-flags-module-materialized-segments", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
      mountPoint: rootRouteRef,
    }),
  );
